<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb" />
    <div class="wrap max-width">
      <div class="form-box">
        <div class="title">
          {{ info.prodtName }}<el-tag size="small" style="margin-left: 20px">{{ info.prodtTypeDsr }}</el-tag>
        </div>
        <div class="title-sub">
          <div class="company-name">{{ info.crtUserNm }}</div>
          <div v-if="info.isCollect" class="collect-name" style="cursor: pointer" @click="unCollect">
            <img class="star-img" :src="require('@/assets/images/星星-active.png')" alt="" @click.stop="unCollect" />
            取消收藏
          </div>
          <div v-else class="collect-name" style="cursor: pointer" @click="collect">
            <img class="star-img" :src="require('@/assets/images/星星.png')" alt="" @click.stop="collect" />
            加入收藏
          </div>
        </div>
        <!-- <div class="product-info">
          <el-descriptions :column="2">
            <el-descriptions-item label="产品网址">{{ info.prodtUrl || '--' }}</el-descriptions-item>
            <el-descriptions-item label="企业经营地">{{ info.companyLocal || '--' }}</el-descriptions-item>
            <el-descriptions-item label="电子邮箱">{{ info.email || '--' }}</el-descriptions-item>
            <el-descriptions-item label="联系电话/手机">{{ info.contractNum || '--' }}/{{ info.contractPhone || '--' }} </el-descriptions-item>
          </el-descriptions>
        </div> -->
        <div class="product-box">
          <el-carousel height="20.83333vw" class="carousel">
            <el-carousel-item v-for="item in pictureList" :key="item">
              <img :src="item" alt="" width="100%" />
            </el-carousel-item>
          </el-carousel>
          <div class="product-content">
            <div class="product-info">
              <el-descriptions :column="2">
                <el-descriptions-item label="产品网址">
                  <a v-if="info.prodtUrl" class="url" :href="info.prodtUrl" target="_blank">{{ info.prodtUrl }}</a>
                  <span v-else>--</span></el-descriptions-item
                >
                <el-descriptions-item label="企业经营地">{{ info.companyLocal || '--' }}</el-descriptions-item>
                <el-descriptions-item label="电子邮箱">{{ info.email || '--' }}</el-descriptions-item>
                <el-descriptions-item label="联系电话/手机">{{ phone }} </el-descriptions-item>
              </el-descriptions>
            </div>
            <div>{{ info.prodtDes }}</div>
          </div>
        </div>
        <div class="tips">注：以上所填写的信息有企业自行提供，内容的真实性、准确性和合法性由发布企业负责。</div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === '我的产品') {
        // 处理语句，可以是 data 中的数据，也可以是 methods中的函数。vm 相当于 this
        vm.breadcrumb = [
          {
            path: '/',
            name: '首页',
            meta: {
              title: '首页',
            },
          },
          {
            path: '/user/myProduct',
            name: '产品收藏',
            meta: {
              title: '产品收藏',
            },
          },
          {
            path: `/product/detial?id=${vm.info.id}`,
            name: '企业产品详情',
            meta: {
              title: '企业产品详情',
            },
          },
        ]
      } else if (from.name === '我的收藏') {
        vm.breadcrumb = [
          {
            path: '/',
            name: '首页',
            meta: {
              title: '首页',
            },
          },
          {
            path: '/user/myCollection',
            name: '产品收藏',
            meta: {
              title: '产品收藏',
            },
          },
          {
            path: `/product/detial?id=${vm.info.id}`,
            name: '企业产品详情',
            meta: {
              title: '企业产品详情',
            },
          },
        ]
      } else {
        vm.breadcrumb = [
          {
            path: '/',
            name: '首页',
            meta: {
              title: '首页',
            },
          },
          {
            path: '/product/list',
            name: '企业产品列表',
            meta: {
              title: '企业产品列表',
            },
          },
          {
            path: `/product/detial?id=${vm.info.id}`,
            name: '企业产品详情',
            meta: {
              title: '企业产品详情',
            },
          },
        ]
      }
    })
  },
  data() {
    return {
      info: {},
      breadcrumb: [],
    }
  },
  computed: {
    pictureList() {
      if (this.info.prodtPictureUrl) {
        return this.info.prodtPictureUrl.split(',')
      }
      return []
    },
    phone() {
      return [this.info.contractNum, this.info.contractPhone].filter(Boolean).join('/')
    },
    // breadcrumb() {
    //   return [
    //     {
    //       path: '/',
    //       name: '首页',
    //       meta: {
    //         title: '首页',
    //       },
    //     },
    //     {
    //       path: '/product/list',
    //       name: '企业产品列表',
    //       meta: {
    //         title: '企业产品列表',
    //       },
    //     },
    //     {
    //       path: `/product/detial?id=${this.info.id}`,
    //       name: '企业产品详情',
    //       meta: {
    //         title: '企业产品详情',
    //       },
    //     },
    //   ]
    // },
  },
  mounted() {
    this.queryDetail(this.$route.query.id)
  },
  methods: {
    unCollect() {
      this.$http({ method: 'get', url: `/zzmh/in/product/unCollect?id=` + this.info.id })
        .then((res) => {
          this.$message.success('操作成功')
          this.queryDetail(this.$route.query.id)
        })
        .catch(() => {})
    },
    collect() {
      this.$http({ method: 'get', url: `/zzmh/in/product/collect?id=` + this.info.id })
        .then((res) => {
          this.$message.success('操作成功')
          this.queryDetail(this.$route.query.id)
        })
        .catch(() => {})
    },
    queryDetail(id) {
      this.$http({ method: 'get', url: '/zzmh/in/product/info/' + id }).then((res) => {
        this.info = res.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .wrap {
    display: flex;
    flex-direction: column;
    .tips {
      color: #666;
      font-size: 14px;
      margin-top: 12px;
    }
    .product-info {
      background: #f6f7fb;
      border-radius: 4px;
      padding: 20px;
      padding-top: 30px;
      /deep/ .el-descriptions__body {
        background: transparent;
      }
      /deep/ .el-descriptions-item__content {
        width: 100%;
        word-break: break-all;
        // white-space: nowrap;
        // text-overflow: ellipsis;
        // overflow: hidden;
      }
      .url {
        color: blue;
        text-decoration: underline;
      }
    }
    .form-box {
      flex: 1;
      background: #fff;
      padding: 30px;
      .title-sub {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #8c8c8c;
        text-align: center;
        font-weight: 400;
        display: flex;
        justify-content: center;
        margin-bottom: 15px;
        align-items: center;
        .star-img {
          width: 24px;
        }
        .collect-name {
          display: flex;
          align-items: center;
        }
      }
      .company-name {
        margin-right: 30px;
      }
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC-Semibold;
        font-size: 24px;
        color: rgba(51, 51, 51, 0.85);
        text-align: center;
        line-height: 24px;
        font-weight: 600;
        margin-bottom: 15px;
      }
    }
    .product-box {
      display: flex;
      margin-top: 20px;
      .carousel {
        width: 533px;
      }
      .product-content {
        flex: 1;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        text-align: justify;
        font-weight: 500;
        margin-left: 20px;
      }
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
